import Vue from "vue";

export const LineItemEventBus = new Vue();

export const LineItemCalculationEventBus = new Vue();

export function hasInvalidLineItemQuantity(lineItems) {
  return (lineItems || []).some(
    (row) => row && row.type !== "header" && Number(row.quantity) < 1
  );
}
